<template>
  <v-app>
    <v-container fluid>
      <v-card
          class="rounded-xl"
          outlined
      >
        <v-tabs
            v-model="tab_item"
            show-arrows
            color="teal accent-4"
        >
          <v-tab>
            <v-icon left>
            </v-icon>
            Ваши курсы
          </v-tab>
          <v-tab v-if="teacher">
            <v-icon left>
            </v-icon>
            Подать заявление на перенос курса
          </v-tab>
          <v-tab v-if="teacher">
            <v-icon left>
            </v-icon>
            Заявления на зачисление групп
          </v-tab>
        </v-tabs>
        <v-card elevation="0">
          <v-tabs-items v-model="tab_item">
            <v-tab-item>
              <v-card flat>
                <v-simple-table>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Название курса
                    </th>
                    <th v-if="teacher">
                      Группы на курсе
                    </th>
                    <th v-if="teacher" class="text-left">
                      Тех. карта ЭУК
                    </th>
                    <th class="text-left">
                      Ссылка на курс
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in courses"
                      :key="item.id"
                  >
                    <td><b>{{ item.fullname }}</b></td>
                    <td v-if="(item.status_tech_map === 'Одобрен' && teacher) || (item.category !== 1 && teacher && item.shortname.slice(0,2) === 'а_')">
                      <v-row align="center">
                        <v-col cols="6">
                          <b v-for="group in item.groups">{{ group.name }}, </b>
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                              elevation="0"
                              class="mx-2"
                              fab
                              dark
                              icon
                              color="success"
                              v-on:click="AddStudents(item)">
                            <v-icon size="25px" dark>
                              fa-plus-circle
                            </v-icon>
                          </v-btn>
                          <v-btn
                              elevation="0"
                              class="mx-2"
                              fab
                              dark
                              icon
                              color="error"
                              v-on:click="DelGroups(item)">
                            <v-icon size="25px" dark>
                              fa-minus-circle
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </td>
                    <td v-else-if="teacher">
                      Невозможно записать группы
                    </td>
                    <td v-if="teacher">
                      <v-row align="center">
                        <v-col cols="6">
                          <v-chip small outlined :color="statusTechMap(item.status_tech_map).color_chip">
                            {{ statusTechMap(item.status_tech_map).status }}
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                              elevation="0"
                              fab
                              dark
                              icon
                              :color="statusTechMap(item.status_tech_map).color_btn"
                              :href="`/study/index_estimation_euk?course_id=${item.id}`"
                          >
                            <v-icon size="25px" dark>
                              {{ statusTechMap(item.status_tech_map).icon }}
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </td>
                    <td>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="getLink(item.id)"
                      >
                        Ссылка
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>
                <v-dialog
                    v-model="dialog_stud"
                    persistent
                    max-width="800"
                >
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Заявление</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <h3>
                              {{ application_stud.cathedral }}
                            </h3>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                                v-model="application_stud.position"
                                label="Должность"
                                required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-simple-table>
                              <thead>
                              <tr>
                                <th class="text-left">
                                  Название курса
                                </th>
                                <th class="text-left">
                                  Номер распоряжения о включении курса в список ЭУК (можно несколько, если они были на
                                  этот курс)
                                </th>
                                <th class="text-left">
                                  Группы для записи
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td>{{ application_stud.course.fullname }}</td>
                                <td>
                                  <v-text-field
                                      :rules="rules"
                                      v-model="application_stud.num"
                                      label="Номер распоряжения"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-col cols="12">
                                    <v-autocomplete
                                        v-model="application_stud.groups"
                                        :items="groups"
                                        dense
                                        chips
                                        small-chips
                                        multiple
                                        solo
                                        item-text="name"
                                        return-object
                                    ></v-autocomplete>
                                  </v-col>
                                </td>
                              </tr>
                              </tbody>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="red darken-1"
                          text
                          @click="dialog_stud = false"
                      >
                        Закрыть
                      </v-btn>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="sendGroupApp()"
                      >
                        Отправить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                    v-model="dialog_del"
                    persistent
                    max-width="800"
                >
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Отчислить группы</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-col cols="12">
                          <v-autocomplete
                              v-model="groups_for_del"
                              :items="course_groups"
                              dense
                              chips
                              small-chips
                              multiple
                              solo
                              item-text="name"
                              return-object
                          ></v-autocomplete>
                        </v-col>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="green darken-1"
                          text
                          @click="dialog_del = false"
                      >
                        Закрыть
                      </v-btn>
                      <v-btn
                          color="red darken-1"
                          text
                          @click="dialog_del_aprove=true"
                      >
                        Отчислить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                    v-model="dialog_del_aprove"
                    persistent
                    max-width="340"
                >
                  <v-card>
                    <v-card-title class="text-h5">
                      Вы действительно хотите удалить группы?
                    </v-card-title>
                    <v-card-text><h5 v-for="group in groups_for_del"> {{group.name}}</h5> из курса <b>{{del_course.fullname}}</b></v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="green darken-1"
                          text
                          @click="dialog_del_aprove = false"
                      >
                        Нет
                      </v-btn>
                      <v-btn
                          color="green darken-1"
                          text
                          @click="delGroup()"
                      >
                        Да
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="teacher">
              <v-card flat>
                <v-toolbar elevation="0">
                  <v-spacer/>
                  <v-btn
                      elevation="0"
                      class="mx-2 rounded-xl"
                      dark
                      color="success"
                      @click="NewApp"
                  >
                    Подать
                    <v-icon right dark>
                      fa-plus
                    </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-simple-table>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Номер заявления
                    </th>
                    <th class="text-left">
                      Посмотреть заявление
                    </th>
                    <th class="text-left">
                      Статус
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in applications"
                      :key="item.id"
                      :style="[
                  item.agreed ? {color: 'green'} : {color: 'red'},
                  item.agreed === null ? {color: 'black'} : null,
              ]"
                  >
                    <td><b>{{ item.id }}</b></td>
                    <td><a v-on:click="GetApp(item)">Просмотр заявления</a></td>
                    <td><h3>
                      <span v-if="item.agreed">Исполненно</span>
                      <span v-else-if="item.agreed!==null">Отклонено</span>
                      <span v-else-if="item.approved">На рассмотрении</span>
                      <span v-else>Сохранено</span>
                    </h3>
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>
                <v-dialog
                    v-model="dialog"
                    persistent
                    max-width="800"
                >
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Заявление</span>
                    </v-card-title>
                    <v-alert type="error" v-if="errors.length">
                      <ul class="list">
                        <li v-for="error in errors">{{ error }}</li>
                      </ul>
                    </v-alert>
                    <v-alert type="warning" v-if="application.agreed === false">
                      Причина отказа: {{ application.comment }}
                    </v-alert>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete
                                v-model="application.cathedral"
                                :items="departments"
                                label="Кафедра"
                                item-text="name"
                                item-value="name"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                                v-model="application.position"
                                label="Должность"
                                required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-simple-table>
                              <thead>
                              <tr>
                                <th class="text-left">
                                  Название курса
                                </th>
                                <th class="text-left">
                                  Ссылка на курс
                                </th>
                                <th class="text-left">
                                  Номер распоряжения о включении курса в список ЭУК
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="item in application.courseslist">
                                <td>
                                  <v-text-field
                                      :rules="rules"
                                      v-model="item.course_name"
                                      label="Название курса"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field
                                      :rules="rules"
                                      v-model="item.course_url"
                                      label="Ссылка на курс"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field
                                      :rules="rules"
                                      v-model="item.order_num"
                                      label="Номер распоряжения"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-btn
                                      class="mx-2"
                                      fab
                                      dark
                                      x-small
                                      color="error"
                                      v-on:click="DelCourse(application.courseslist.indexOf(item))">
                                    <v-icon dark>
                                      fa-trash
                                    </v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                              </tbody>
                              <tfoot>
                              <th>
                                <v-btn
                                    class="mx-2"
                                    fab
                                    dark
                                    x-small
                                    color="success"
                                    v-on:click="AddCourse">
                                  <v-icon dark>
                                    fa-plus
                                  </v-icon>
                                </v-btn>
                              </th>
                              </tfoot>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="red darken-1"
                          text
                          @click="dialog = false"
                      >
                        Закрыть
                      </v-btn>
                      <v-btn
                          v-if="application.agreed !== true"
                          color="green darken-1"
                          text
                          @click="saveApplication"
                      >
                        Сохранить
                      </v-btn>
                      <v-btn
                          v-if="!application.approved || application.agreed !== true"
                          :disabled="errors.length > 0"
                          color="blue darken-1"
                          text
                          @click="sendApplication"
                      >
                        Отправить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="teacher">
              <v-card flat>
                <v-simple-table>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Группы
                    </th>
                    <th class="text-left">
                      Имя курса
                    </th>
                    <th class="text-left">
                      Статус
                    </th>
                    <th class="text-left">
                      Недочеты
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in applications_stud"
                      :key="item.id"
                      :style="[
                    item.agreed ? {color: 'green'} : {color: 'red'},
                    item.agreed === null ? {color: 'black'} : null,
                ]"
                  >
                    <td><b v-for="group in item.groups">{{ group.name }}, </b></td>
                    <td>{{ item.course.fullname }}</td>
                    <td><h5>
                      <span v-if="item.agreed">Исполненно</span>
                      <span v-else-if="item.agreed!==null">Отклонено</span>
                      <span v-else>На рассмотрении</span>
                    </h5>
                    </td>
                    <td> {{ item.message }}</td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  name: "estudy_index",
  data: () => ({
    courses: [],
    applications: [],
    applications_stud: [],
    teacher: false,
    dialog: false,
    dialog_stud: false,
    dialog_del: false,
    dialog_del_aprove: false,
    groups: [],
    departments: [],
    application: {
      id: 0,
      cathedral: '',
      position: '',
      courseslist: [{'course_name': '', 'course_url': '', 'order_num': ''},],
      approved: false,
      agreed: false,
      comment: "",
    },
    application_stud: {
      cathedral: '',
      position: '',
      num: '',
      agreed: null,
      course: [],
      groups: [],
    },
    save: true,
    rules: [
      value => !!value || 'Обязательно для заполнения перед отправкой',
    ],
    del_course: [],
    course_groups: [],
    groups_for_del: [],
    tab_item: ''
  }),
  computed: {
    errors: function () {
      let errors = [];
      this.application.courseslist.forEach(item => {
        if (item.order_num === '') {
          errors.push('Не заполнен номер распоряжения')
        }
        if (item.course_url === '') {
          errors.push('Не заполнена ссылка на курс')
        }
        if (item.course_name === '') {
          errors.push('Не заполнена имя курса')
        }
      })
      return errors
    }
  },
  methods: {
    getCourses() {
      axios({
        method: 'get',
        url: `/study/moodle_courses`,
      }).then((response) => {
        this.courses = response.data.courses;
        this.teacher = response.data.teacher;
        this.applications = response.data.applications;
        this.departments = response.data.departments;
        this.groups = response.data.groups;
        this.applications_stud = response.data.applications_stud;
      }).catch((error) => {
        return error;
      });
    },
    NewApp() {
      this.dialog = !this.dialog
      this.application = {
        id: 0,
        cathedral: '',
        position: '',
        courseslist: [{'course_name': '', 'course_url': '', 'order_num': ''},]
      }
      this.save = true
    },
    GetApp(item) {
      this.dialog = true
      this.application.id = item.id
      this.application.courseslist = item.courseslist
      this.application.cathedral = item.cathedral
      this.application.position = item.position
      this.application.approved = item.approved
      this.application.agreed = item.agreed
      this.application.comment = item.comment
      this.application.agreed = item.agreed
      this.save = true
    },
    AddCourse() {
      this.application.courseslist.push({'course_name': '', 'course_url': '', 'order_num': ''})
    },
    DelCourse(index) {
      this.application.courseslist.splice(index, 1)
    },
    saveApplication() {
      this.dialog = false
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      if (this.application.id !== 0) {
        axios({
          method: 'put',
          url: '/study/update_application/' + this.application.id,
          data: {
            course_application: {
              cathedral: this.application.cathedral,
              position: this.application.position,
              courseslist: this.application.courseslist,
              agreed: null
            },
          }
        }).then((response) => {
          if (response.status === 200 || response.status === 204) {
            this.getCourses()
          }
        }).catch((error) => {
          return error;
        });
      } else {
        axios({
          method: 'post',
          url: '/study/create_application/false',
          data: {
            course_application: {
              cathedral: this.application.cathedral,
              position: this.application.position,
              courseslist: this.application.courseslist,
              agreed: null
            },
          }
        }).then((response) => {
          if (response.status === 200 || response.status === 204) {
            this.application = {
              id: 0,
              cathedral: '',
              position: '',
              courseslist: [{'course_name': '', 'course_url': '', 'order_num': ''},]
            }
            this.getCourses()
          }
        }).catch((error) => {
          return error;
        });
      }
    },
    sendApplication() {
      this.dialog = false
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      if (this.application.id !== 0) {
        axios({
          method: 'put',
          url: '/study/send_application/' + this.application.id,
          data: {
            course_application: {
              cathedral: this.application.cathedral,
              position: this.application.position,
              courseslist: this.application.courseslist,
              agreed: null
            },
          }
        }).then((response) => {
          if (response.status === 200 || response.status === 204) {
            this.getCourses()
          }
        }).catch((error) => {
          return error;
        });
      } else {
        axios({
          method: 'post',
          url: '/study/create_application/true',
          data: {
            course_application: {
              cathedral: this.application.cathedral,
              position: this.application.position,
              courseslist: this.application.courseslist,
              agreed: null
            },
          }
        }).then((response) => {
          if (response.status === 200 || response.status === 204) {
            this.application = {
              id: 0,
              cathedral: '',
              position: '',
              courseslist: [{'course_name': '', 'course_url': '', 'order_num': ''},]
            }
            this.getCourses()
          }
        }).catch((error) => {
          return error;
        });
      }
    },
    sendGroupApp() {
      this.dialog_stud = false
      const token = document.querySelector('[name=csrf-token]').content;
      this.application_stud.course.num = this.application_stud.num
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'post',
        url: `/study/create_group_application`,
        data: {
          group_application: {
            cathedral: this.application_stud.cathedral,
            position: this.application_stud.position,
            groups: this.application_stud.groups,
            course: this.application_stud.course,
            agreed: null
          },
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {

        }
      }).catch((error) => {
        return error;
      });
    },
    delGroup() {
      this.dialog_del = false
      this.dialog_del_aprove = false
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'post',
        url: `/study/unenroll_stud`,
        data: {
          unenroll: {
            groups: this.groups_for_del,
          },
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          this.getCourses()
        }
      }).catch((error) => {
        return error;
      });
    },
    getLink(id) {
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'get',
        url: `/study/auth?w_url=https://newmoodle.amursu.ru/course/view.php?id=${id}`,
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          window.open(response.data.url, '_blank')
        }
        this.getCourses()
      }).catch((error) => {
        return error;
      });
    },
    AddStudents(course) {
      this.application_stud = {
        cathedral: '',
        position: '',
        num: '',
        agreed: null,
        course: [],
        groups: [],
      }
      this.dialog_stud = true
      this.application_stud.cathedral = course.categoryname
      this.application_stud.course = course
    },
    DelGroups(course) {
      this.dialog_del = true
      this.course_groups = course.groups
      this.del_course = course
    },
    statusTechMap(status_tech_map){
      switch (status_tech_map){
        case 'Рассматривается':
          return { status: status_tech_map, color_btn: 'orange', color_chip: 'orange', icon: "fa-exclamation-circle" }
        case 'Одобрен':
          return { status: status_tech_map, color_btn: 'green', color_chip: 'green', icon: "fa-exclamation-circle" }
        case 'Отклонен':
          return { status: status_tech_map, color_btn: 'red', color_chip: 'red', icon: "fa-exclamation-circle"}
      }

     return { status: status_tech_map, color_btn: 'green', color_chip: 'grey', icon: "fa-plus-circle" }
    },
  },
  mounted() {
    this.getCourses()
  }
}
</script>

<style scoped>
</style>